function initializeStore() {
	const externalStore = window.store && window.store.store;
	if (!externalStore) {
		console.error("Redux store not found on window.store.store");
		return null;
	}

	return externalStore;
}

export { initializeStore };